import React from 'react';
import {NavLink} from 'react-router-dom';
import styled from 'styled-components';

const StyledNavLink = styled(NavLink)`
  color: #d0250d;
  text-decoration: underline;
  font-size: 14px;
`;
export default function NavigationLink(props) {
  return (
    <StyledNavLink {...props} activeClassName="active">
      {props.children}
    </StyledNavLink>
  );
}
